<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <div id="contenedor" style="position: absolute; visibility: hidden;"></div>
        <!-- Modal categoría -->
        <v-dialog v-model="verCategoria" max-width="250px" persistent>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>Categoría</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="guardarCategoria" :loading="desabilitarCat" :disabled="desabilitarCat || !isValidPer">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn icon @click="closeCategoria">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="isValidPer">
                <v-row class="mt-1">
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="nombre_categoria" label="Nombre" maxlength="50"
                      :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 50) || 'Nombre debe tener entre 3 a 50 caracteres', Rules.unespacio]"
                      v-uppercase hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Modal categoría -->

        <!-- Modal marca -->
        <v-dialog v-model="verMarca" max-width="250px" persistent>
          <v-card>
            <v-toolbar dark dense class="primary" flat>
              <v-toolbar-title>Marca</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="guardarMarca" :loading="desabilitarMar" :disabled="desabilitarMar || !isValidMar">
                <v-icon>save</v-icon>
              </v-btn>
              <v-btn icon @click="closeMarca">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="isValidMar">
                <v-row class="mt-1">
                  <v-col cols="12">
                    <v-text-field dense v-model.trim="nombre_marca" label="Nombre" maxlength="30"
                      :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 2 && v.length <= 30) || 'Nombre debe tener entre 2 a 30 caracteres', Rules.unespacio]"
                      v-uppercase hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Modal marca -->

        <!-- Productos  -->
        <v-data-table :loading="loading" :headers="headers" :items="productos" :items-per-page="15"
          item-key="idproducto" show-expand class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">PRODUCTOS</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <!-- pdf y excel -->
              <v-btn icon small color="print" @click="crearPDF()" :loading="loading" :disabled="loading" class="mr-1">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn icon small color="success" @click="crearXLSX()" :loading="loading" :disabled="loading"
                class="mr-1">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin pdf y excel -->
              <v-spacer />
              <!-- busqueda -->
              <v-select v-model="idsucursal" dense :items="sucursales" label="Establecimiento Stock"
                :rules="[v => v !== null && v !== undefined || 'Requerido']"
                @change="listar(), sucursalSeleccionado(idsucursal)" class="mr-1" style="max-width: 180px;"
                hide-details></v-select>
              <v-text-field class="mr-1 text-xs-center" v-model.trim="buscar" dense label="Búsqueda" single-line
                @keyup="listar" clearable hide-details></v-text-field>
              <!-- Fin busqueda -->
              <v-spacer />
              <v-switch v-model="todoProductos" hide-details @click="listar" label="Todo" class="mr-1" dense>
              </v-switch>
              <v-spacer />
              <!-- Modal producto -->
              <v-dialog v-model="dialog" max-width="740px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" class="hidden-sm-and-down" v-on="on" small outlined>Nuevo</v-btn>
                  <v-btn color="primary" class="hidden-md-and-up" v-on="on" fab x-small outlined>
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-tabs v-model="tab" background-color="primary" dark>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1">{{ formTitle }}</v-tab>
                    <v-tab href="#tab-2">Imagen</v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-card-text>
                          <v-form v-model="isValid">
                            <v-row>
                              <v-col cols="12" md="3" sm="3">
                                <v-text-field dense v-model.trim="codigo_producto" label="Cód. Producto"
                                  :rules="[Rules.unespacio]" maxlength="40" v-uppercase hide-details
                                  clearable></v-text-field>
                              </v-col>
                              <v-col cols="12" md="3" sm="3">
                                <v-text-field dense v-model.trim="codigo_producto2" label="Cód. Producto 2"
                                  :rules="[Rules.unespacio]" maxlength="40" v-uppercase hide-details
                                  clearable></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6" sm="6">
                                <v-text-field dense v-model.trim="descripcion" label="Nombre"
                                  :rules="[v => !!v || 'Requerido', Rules.unespacio]" maxlength="200" v-uppercase
                                  hide-details clearable></v-text-field>
                              </v-col>
                              <v-col cols="12" md="3" sm="3">
                                <v-text-field dense v-model.trim="codigo_barra" label="Código Barra"
                                  :rules="[Rules.sinespacio]" maxlength="30" hide-details clearable></v-text-field>
                              </v-col>
                              <v-col cols="12" md="3" sm="3">
                                <v-autocomplete dense @keyup="selectCategoria()" :search-input.sync="buscar_categoria"
                                  :items="categorias" v-model="idcategoria" label="Categoría"
                                  prepend-inner-icon="playlist_add" @click:prepend-inner="mostrarCategoria"
                                  :rules="[v => !!v || 'La categoría es requerido']" required hide-details>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="3" sm="3">
                                <v-autocomplete dense @keyup="selectMarca()" :search-input.sync="buscar_marca"
                                  :items="marcas" v-model="idmarca" label="Marca" prepend-inner-icon="playlist_add"
                                  @click:prepend-inner="mostrarMarca" :rules="[v => !!v || 'La marca es requerido']"
                                  hide-details></v-autocomplete>
                              </v-col>
                              <v-col cols="8" sm="3" md="3">
                                <v-autocomplete dense :items="unidad_medidas" v-model="idunidad_medida"
                                  label="Unidad Medida" :rules="[v => !!v || 'La unidad de medida es requerido']"
                                  required hide-details></v-autocomplete>
                              </v-col>
                              <v-col cols="4" md="2" sm="2">
                                <v-text-field type="text" dense v-model="stock_minimo" label="Stock Minimo"
                                  :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="5"
                                  @keypress="common.isNum($event)" hide-details></v-text-field>
                              </v-col>
                              <v-col cols="12" md="5" sm="5">
                                <v-autocomplete dense @keyup="selectProdSunat()" :search-input.sync="buscar_prodsunat"
                                  v-model="idprod_sunat" :items="prod_sunats" label="Producto Sunat"
                                  :rules="[v => !!v || 'El producto es requerido']" hide-details clearable>
                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" md="5" sm="5">
                                <v-select dense v-model="idtipo_afectacion" :items="tipo_afectacion"
                                  label="Tipo Afectación" :rules="[v => !!v || 'La afectación es requerido']"
                                  hide-details></v-select>
                              </v-col>
                            </v-row>
                            <!-- Precios Compra -->
                            <v-container>
                              <v-toolbar-title class="mb-2 primary--text">Precios de compra</v-toolbar-title>
                              <v-row>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="precio_unit_comprad"
                                    label="P/U Compra Dolares" :rules="[v => (!!v && v > 0) || 'Requerido']"
                                    maxlength="9" prefix="$"
                                    @keyup.prevent="precio_unit_compras = common.roundOut((common.valDec(precio_unit_comprad) * tc), 4)"
                                    @keyup.native="precio_unit_venta = calcularPV, precio_unit_cliente = calcularPC, precio_unit_distribuidor = calcularPD"
                                    @keypress="common.numDec($event, precio_unit_comprad, 4)" onClick="this.select()"
                                    hide-details></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="precio_unit_compras" label="P/U Compra Soles"
                                    :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9" prefix="S/"
                                    @keyup.prevent="precio_unit_comprad = common.roundOut((common.valDec(precio_unit_compras) / tc), 4)"
                                    @keyup.native="precio_unit_venta = calcularPV, precio_unit_cliente = calcularPC, precio_unit_distribuidor = calcularPD"
                                    @keypress="common.numDec($event, precio_unit_compras, 4)" onClick="this.select()"
                                    hide-details></v-text-field>
                                </v-col>
                                <!-- <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="otrosd" label="Otros Dolares" maxlength="10"
                                    prefix="$" @keyup.prevent="otross = common.roundOut((common.valDec(otrosd) * tc), 4)"
                                    @keyup.native="precio_unit_venta = calcularPV, precio_unit_cliente = calcularPC, precio_unit_distribuidor = calcularPD"
                                    @keypress="common.numDec($event, otrosd, 4)" onClick="this.select()"
                                    hide-details></v-text-field>
                                </v-col>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="otross" label="Otros Soles" maxlength="10"
                                    prefix="S/" @keyup.prevent="otrosd = common.roundOut((common.valDec(otross) / tc), 4)"
                                    @keyup.native="precio_unit_venta = calcularPV, precio_unit_cliente = calcularPC, precio_unit_distribuidor = calcularPD"
                                    @keypress="common.numDec($event, otross, 4)" onClick="this.select()"
                                    hide-details></v-text-field> 
                                </v-col>-->
                              </v-row>
                            </v-container>
                            <!-- Precios Venta -->
                            <v-container>
                              <v-toolbar-title class="mb-2 primary--text">Precios de venta</v-toolbar-title>
                              <v-row>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="utilidad_unit_venta" label="Ganancia Venta"
                                    :rules="[v => (!!v && v > 0) || 'Requerido']" suffix="%" maxlength="10"
                                    @keypress="common.numDec($event, utilidad_unit_venta, 4)" onClick="this.select()"
                                    @keyup.prevent="precio_unit_venta = common.roundOut(((common.valDec(precio_unit_compras) + common.valDec(otross)) + ((common.valDec(precio_unit_compras) + common.valDec(otross)) * common.valDec(utilidad_unit_venta)) / 100), 2)"
                                    hide-details></v-text-field>
                                </v-col>
                                <v-col cols="6" md="4" sm="4">
                                  <v-text-field type="text" dense v-model="precio_unit_venta" label="P/U/Venta"
                                    :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9" prefix="S/"
                                    @keypress="common.numDec($event, precio_unit_venta, 4)" onClick="this.select()"
                                    @keyup.prevent="utilidad_unit_venta = common.roundOut((((common.valDec(precio_unit_venta) - (common.valDec(precio_unit_compras) + common.valDec(otross))) / (common.valDec(precio_unit_compras) + common.valDec(otross))) * 100), 4)"
                                    hide-details></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="utilidad_unit_cliente"
                                    label="Ganancia Cliente" :rules="[v => (!!v && v > 0) || 'Requerido']" suffix="%"
                                    maxlength="10" @keypress="common.numDec($event, utilidad_unit_cliente, 4)"
                                    onClick="this.select()"
                                    @keyup.prevent="precio_unit_cliente = common.roundOut(((common.valDec(precio_unit_compras) + common.valDec(otross)) + ((common.valDec(precio_unit_compras) + common.valDec(otross)) * common.valDec(utilidad_unit_cliente)) / 100), 2)"
                                    hide-details></v-text-field>
                                </v-col>
                                <v-col cols="6" md="4" sm="4">
                                  <v-text-field type="text" dense v-model="precio_unit_cliente" label="P/U/Cliente"
                                    :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9" prefix="S/"
                                    @keypress="common.numDec($event, precio_unit_cliente, 4)" onClick="this.select()"
                                    @keyup.prevent="utilidad_unit_cliente = common.roundOut((((common.valDec(precio_unit_cliente) - (common.valDec(precio_unit_compras) + common.valDec(otross))) / (common.valDec(precio_unit_compras) + common.valDec(otross))) * 100), 4)"
                                    hide-details></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6" md="3" sm="3">
                                  <v-text-field type="text" dense v-model="utilidad_unit_distribuidor"
                                    label="Ganancia Distribuidor" :rules="[v => (!!v && v > 0) || 'Requerido']"
                                    suffix="%" maxlength="10"
                                    @keypress="common.numDec($event, utilidad_unit_distribuidor, 4)"
                                    onClick="this.select()"
                                    @keyup.prevent="precio_unit_distribuidor = common.roundOut(((common.valDec(precio_unit_compras) + common.valDec(otross)) + ((common.valDec(precio_unit_compras) + common.valDec(otross)) * common.valDec(utilidad_unit_distribuidor)) / 100), 2)"
                                    hide-details></v-text-field>
                                </v-col>
                                <v-col cols="6" md="4" sm="4">
                                  <v-text-field type="text" dense v-model="precio_unit_distribuidor"
                                    label="P/U/Distribuidor" :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="9"
                                    prefix="S/" @keypress="common.numDec($event, precio_unit_distribuidor, 4)"
                                    onClick="this.select()"
                                    @keyup.prevent="utilidad_unit_distribuidor = common.roundOut((((common.valDec(precio_unit_distribuidor) - (common.valDec(precio_unit_compras) + common.valDec(otross))) / (common.valDec(precio_unit_compras) + common.valDec(otross))) * 100), 4)"
                                    hide-details></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" class="mb-4" align="center">
                              <template color="teal" v-if="file">
                                <v-avatar tile size="250">
                                  <v-img :src="urlTemporal" @click="$refs.boton.click()" />
                                </v-avatar>
                              </template>
                              <template v-else-if="imagen == ''">
                                <v-avatar tile size="250">
                                  <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton.click()" />
                                </v-avatar>
                              </template>
                              <template color="teal" v-else>
                                <v-avatar tile size="250">
                                  <img :src="'data:image/png;base64,' + imagen" @click="$refs.boton.click()" />
                                </v-avatar>
                              </template>
                              <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                                @change="buscarImagen($event)" class="d-none" />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>

                  <v-card-actions class="py-0 pb-3 justify-center">
                    <v-btn color="error" @click="close" small outlined>
                      <v-icon left>close</v-icon>Cancelar
                    </v-btn>
                    <v-btn color="primary" @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid"
                      small outlined>
                      <v-icon left>check</v-icon>Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal producto -->

              <!-- Modal activar y desactivar -->
              <v-dialog v-model="adModal" max-width="295">
                <v-card>
                  <v-card-title class="justify-center" v-if="adAccion == 1">¿Activar Producto?</v-card-title>
                  <v-card-title class="justify-center" v-if="adAccion == 2">¿Desactivar Producto?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    el codigo de producto {{ adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn color="success" @click="activarDesactivarCerrar" small outlined>Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" color="info" @click="activar" small outlined>Activar</v-btn>
                    <v-btn v-if="adAccion == 2" color="info" @click="desactivar" small outlined>Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar y desactivar -->

              <!-- Modal kardex -->
              <v-dialog v-model="adModalKardex" max-width="1280" persistent>
                <v-card>
                  <v-toolbar dark dense class="accent" flat>
                    <v-toolbar-title>KARDEX: {{ codigo_producto }} | {{ descripcion }} | {{ categoria }} | {{ marca
                    }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon @click="cerrarKardex">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card>
                    <v-data-table :loading="loadingKardex" :headers="headersKardexs" :items="kardexs"
                      :items-per-page="15" dense>
                      <template v-slot:item.fecha="{ item }">
                        <strong>{{ item.fecha | formatearFecha }}</strong>
                      </template>
                      <template v-slot:item.movimiento="{ item }">
                        <strong>{{ item.movimiento }} {{ item.moneda == "S" ? " S/" : item.moneda == "D" ? "$"
                          : "" }}</strong>
                      </template>
                      <template v-slot:item.entrada_valor="{ item }">
                        <div class="text-right">
                          <span>{{ common.roundOut(item.entrada_valor, 2) | formatearNumero }}</span>
                        </div>
                      </template>
                      <template v-slot:item.comprobante="{ item }">
                        <strong>{{ item.comprobante }}</strong>
                      </template>
                      <template v-slot:item.salida_valor="{ item }">
                        <div class="text-right">
                          <span>{{ common.roundOut(item.salida_valor, 2) | formatearNumero }}</span>
                        </div>
                      </template>
                      <template v-slot:item.saldo_valor="{ item }">
                        <div class="text-right">
                          <span>{{ common.roundOut(item.saldo_valor, 2) | formatearNumero }}</span>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card>
              </v-dialog>
              <!-- Fin Modal kardex -->

              <!-- Modal código barra -->
              <v-dialog v-model="adModalBarra" max-width="500" persistent>
                <v-card>
                  <v-toolbar dark dense class="info" flat>
                    <v-toolbar-title>{{ codigo_producto }} {{ marca }}</v-toolbar-title>
                    <v-spacer />
                    <v-text-field dense solo-inverted type="text" v-model="cantCodigos" label="Cantidad"
                      :rules="[v => (!!v && v > 0) || 'Requerido']" maxlength="4" hide-details class="center-input"
                      style="max-width: 60px;" @keypress="common.isNum($event)" onClick="this.select()"></v-text-field>
                    <v-btn icon @click="crearBarCode()" :disabled="cantCodigos > 0 ? false : true">
                      <v-icon>print</v-icon>
                    </v-btn>
                    <v-btn icon @click="cerrarBarCode">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                </v-card>
              </v-dialog>
              <!-- Fin Modal código barra -->
            </v-toolbar>
          </template>

          <!-- Opciones -->
          <template v-slot:item.imagen="{ item }">
            <template>
              <v-avatar tile size="30">
                <img :src="'data:image/png;base64,' + item.imagen" />
              </v-avatar>
            </template>
          </template>

          <template v-slot:item.codigos="{ item }">
            <strong class="primary--text">{{ item.codigo_producto }}</strong> <br /> {{ item.codigo_producto2 }}
          </template>
          <template v-slot:item.marca="{ item }">
            <strong class="error--text">{{ item.marca }}</strong>
          </template>

          <template v-slot:item.stockactual="{ item }">
            <template v-if="item.stockactual == item.stock_minimo">
              <v-chip color="warning" small dark>{{ item.stockactual }}</v-chip>
            </template>
            <template v-else-if="item.stockactual > item.stock_minimo">
              <v-chip color="success" small dark>{{ item.stockactual }}</v-chip>
            </template>
            <template v-else>
              <v-chip color="error" small dark>{{ item.stockactual }}</v-chip>
            </template>
          </template>

          <template v-slot:item.precio_unit_venta="{ item }">
            <strong>{{ item.precio_unit_venta | formatearNumero }}</strong>
          </template>

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text small color="info" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="info" icon v-bind="attrs" v-on="on" @click="mostrarBarCode(item)">qr_code</v-icon>
              </template>
              <span>Cod. Barra</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="accent" icon v-bind="attrs" v-on="on" @click="mostrarKardex(item)">assignment</v-icon>
              </template>
              <span>Kardex</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" icon v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
              </template>
              <span>Modificar</span>
            </v-tooltip>
            <v-btn small icon>
              <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
            </v-btn>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <strong>Fecha Actualizado:</strong>
              {{ item.fecha_modificacion | formatearFechaHm }}
              <strong>U/M:</strong>
              {{ item.idunidad_medida }}
            </td>
          </template>
          <!-- Fin Opciones -->
        </v-data-table>
        <!-- Fin productos -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import XLSX from "xlsx";
import Barcode from "jsbarcode";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      productos: [],
      kardexs: [],
      dialog: false,
      headers: [
        { text: "...", value: "data-table-expand", align: "center" },
        { text: "", value: "imagen", align: "center", sortable: false },
        //{ text: "U/M", value: "idunidad_medida", sortable: false },
        { text: "CÓDIGOS", value: "codigos", sortable: false },
        { text: "NOMBRE", value: "descripcion", sortable: false },
        { text: "CATEGORÍA", value: "categoria", sortable: false },
        { text: "MARCA", value: "marca", sortable: false, divider: true },
        { text: "STOCK", value: "stockactual", sortable: false, align: "center" },
        { text: "P/U/V", value: "precio_unit_venta", sortable: false, align: "right", divider: true },
        { text: "CONDICIÓN", align: "center", value: "condicion", sortable: false },
        { text: "OPCIÓN", value: "opciones", sortable: false, width: 145, align: "center" },
      ],

      headersKardexs: [
        { text: "Fechas", value: "fecha", sortable: false },
        { text: "Movimientos", value: "movimiento", sortable: false },
        { text: "Comprobantes", value: "comprobante", align: "center", sortable: false, width: 140 },
        { text: "Personas", value: "persona", sortable: false },
        { text: "Entrada Cantidad", value: "entrada_cantidad", align: "center", sortable: false },
        { text: "Salida Cantidad", value: "salida_cantidad", align: "center", sortable: false },
        { text: "Saldo Cantidad", value: "saldo_cantidad", align: "center", sortable: false, divider: true },
        { text: "Entrada Valor", value: "entrada_valor", align: "center", sortable: false, },
        { text: "Salida Valor", value: "salida_valor", align: "center", sortable: false, },
        { text: "Saldo Valor", value: "saldo_valor", align: "center", sortable: false, },
      ],

      loading: false,
      loadingKardex: false,

      buscar: "",
      buscar_categoria: "",
      buscar_marca: "",
      buscar_prodsunat: "",

      idsucursal: "",
      sucursales: [{ text: "TODOS", value: 0 }],
      sucursal: "",

      editedIndex: -1,

      idproducto: "",
      idcategoria: "",
      categorias: [],
      idmarca: "",
      marcas: [],

      idunidad_medida: "NIU",
      unidad_medidas: [],

      imagen: "",
      codigo_barra: "",
      codigo_producto: "",
      codigo_producto2: "",
      stock_minimo: 1,
      descripcion: "",
      categoria: "",
      marca: "",
      idprod_sunat: "00000000", // prod_sunats
      idtipo_afectacion: "10",
      precio_unit_compras: 0,
      precio_unit_comprad: 0,

      otrosd: 0,
      otross: 0,

      utilidad_unit_venta: 35,
      utilidad_unit_cliente: 20,
      utilidad_unit_distribuidor: 20,

      precio_unit_venta: 0,
      precio_unit_cliente: 0,
      precio_unit_distribuidor: 0,

      prod_sunats: [],
      tipo_afectacion: [],

      todoProductos: false,

      igv: 0,
      tc: 0,

      // Categoria
      nombre_categoria: "",
      desabilitarCat: false,
      verCategoria: false,
      isValidPer: true,
      // Marca
      nombre_marca: "",
      desabilitarMar: false,
      verMarca: false,
      isValidMar: true,
      // Producto
      desabilitar: false,
      isValid: true,

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      adModalBarra: 0,
      adModalKardex: 0,
      cantCodigos: 1,

      file: null,
      urlTemporal: "",
      tab: null,
      imagenxdefec:
        "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",
      /* Validaciones */
      Rules: {
        sinespacio: (v) => (v || "").indexOf(" ") < 0 || "Sin espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapState(["usuario", "logo", "datos"]),

    calcularPV() {
      return this.common.roundOut(
        this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross) + ((this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross)) * this.common.valDec(this.utilidad_unit_venta)) / 100, 2);
    },
    calcularPC() {
      return this.common.roundOut(
        this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross) + ((this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross)) * this.common.valDec(this.utilidad_unit_cliente)) / 100, 2);
    },
    calcularPD() {
      return this.common.roundOut(
        this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross) + ((this.common.valDec(this.precio_unit_compras) + this.common.valDec(this.otross)) * this.common.valDec(this.utilidad_unit_distribuidor)) / 100, 2);
    },

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Producto" : "Actualizar Producto";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.idsucursal = parseInt(this.usuario.idsucursal);
    this.listar();
    this.select();
    this.selectCategoria();
    this.selectMarca();
    this.igv = parseFloat(this.datos.igv);
    this.tc = parseFloat(this.datos.tc);
    this.selectProdSunat(this.idprod_sunat);
  },

  methods: {
    ...mapActions(["snackBar"]),

    sucursalSeleccionado(idsucursal) {
      const selectId = this.sucursales.find(
        (elemento) => elemento.value === idsucursal
      );
      this.sucursal = selectId.text;
    },

    //#region SELECT
    select() {
      let me = this;
      var sucursalesArray = [];
      axios.get("api/Sucursales/Select")
        .then(function (response) {
          sucursalesArray = response.data;
          sucursalesArray.map(function (x) {
            me.sucursales.push({ text: x.nombre, value: x.idsucursal });
          });
          me.sucursalSeleccionado(me.idsucursal);
        })
        .catch(function (error) {
          //console.log(error);
        });

      var tipo_afectacionArray = [];
      axios.get("api/Tipo_Afectacion/Select")
        .then(function (response) {
          tipo_afectacionArray = response.data;
          tipo_afectacionArray.map(function (x) {
            me.tipo_afectacion.push({
              text: x.descripcion,
              value: x.idtipo_afectacion,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });

      var unidad_medidasArray = [];
      axios.get("api/Unidad_Medidas/Select")
        .then(function (response) {
          unidad_medidasArray = response.data;
          unidad_medidasArray.map(function (x) {
            me.unidad_medidas.push({
              text: x.nombre,
              value: x.idunidad_medida,
            });
          });
        })
        .catch(function (error) { });
    },

    selectCategoria(id) {
      let me = this;

      var categoriasArray = []; // Limpiamos para cargar nuevamente

      if (id) {
        axios.get("api/Categorias/SelectCategorias/" + id)
          .then(function (response) {
            categoriasArray = response.data;
            categoriasArray.map(function (x) {
              me.categorias.push({ text: x.nombre, value: x.idcategoria });
            });
          })
          .then((data) => { })
          .catch(function (error) {
            //console.log(error);
          });
      } else {
        axios.get("api/Categorias/SelectCategoriasFiltro", {
          params: {
            buscar:
              me.buscar_categoria == ""
                ? "-"
                : me.buscar_categoria == null
                  ? "-"
                  : me.buscar_categoria
          },
        })
          .then(function (response) {
            categoriasArray = response.data;
            categoriasArray.map(function (x) {
              me.categorias.push({ text: x.nombre, value: x.idcategoria });
            });
          })
          .then((data) => { })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },

    selectMarca(id) {
      let me = this;

      var marcasArray = []; // Limpiamos para cargar nuevamente

      if (id) {
        axios.get("api/Marcas/SelectMarcas/" + id)
          .then(function (response) {
            marcasArray = response.data;
            marcasArray.map(function (x) {
              me.marcas.push({ text: x.nombre, value: x.idmarca });
            });
          })
          .then((data) => { })
          .catch(function (error) {
            //console.log(error);
          });
      } else {
        axios.get("api/Marcas/SelectMarcasFiltro", {
          params: {
            buscar:
              me.buscar_marca == ""
                ? "-"
                : me.buscar_marca == null
                  ? "-"
                  : me.buscar_marca
          },
        })
          .then(function (response) {
            marcasArray = response.data;
            marcasArray.map(function (x) {
              me.marcas.push({ text: x.nombre, value: x.idmarca });
            });
          })
          .then((data) => { })
          .catch(function (error) {
            //console.log(error);
          });
      }
    },

    selectProdSunat(id) {
      let me = this;
      var prodSunatArray = []; // Limpiamos para cargar nuevamente

      let url = "";
      if (id) {
        url = "api/Prod_Sunats/SelectProductosSunat/" + id;
      } else {
        url =
          "api/Prod_Sunats/SelectProductosSunatFiltro?buscar=" + (me.buscar_prodsunat == "" ? "-" : me.buscar_prodsunat); // si el valor es vacio lo cambiamos a -
      }

      axios.get(url)
        .then(function (response) {
          prodSunatArray = response.data;
          prodSunatArray.map(function (x) {
            me.prod_sunats.push({
              text: x.idprod_sunat + " " + x.descripcion,
              value: x.idprod_sunat,
            });
          });
        })
        .then((data) => {
          this.changeCliente(id); // En observacion
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    //#endregion SELECT

    listar() {
      let me = this;
      me.loading = true;

      axios.get("api/Productos/Listar", {
        params: {
          idsucursal: me.idsucursal,
          buscar: me.buscar == "" ? "-" : me.buscar == null ? "-" : me.buscar,
          todo: me.todoProductos,
        },
      })
        .then(function (response) {
          me.productos = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Producto */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        axios.put("api/Productos/Actualizar", {
          idproducto: me.idproducto,
          idcategoria: me.idcategoria,
          idmarca: me.idmarca,
          idunidad_medida: me.idunidad_medida,
          imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
          codigo_barra: me.codigo_barra = null ? '' : me.codigo_barra,
          codigo_producto: me.codigo_producto == null ? '' : me.codigo_producto,
          codigo_producto2: me.codigo_producto2 == null ? '' : me.codigo_producto2,
          stock_minimo: parseInt(me.stock_minimo),
          descripcion: me.descripcion,

          idprod_sunat: me.idprod_sunat,
          idtipo_afectacion: me.idtipo_afectacion,
          precio_unit_compras: me.precio_unit_compras,
          precio_unit_comprad: me.precio_unit_comprad,

          otrosd: me.otrosd == "" ? 0 : me.otrosd,
          otross: me.otross == "" ? 0 : me.otross,

          utilidad_unit_venta: me.utilidad_unit_venta == "" ? 0 : me.utilidad_unit_venta,
          precio_unit_venta: me.precio_unit_venta == "" ? 0 : me.precio_unit_venta,

          utilidad_unit_cliente: me.utilidad_unit_cliente == "" ? 0 : me.utilidad_unit_cliente,
          precio_unit_cliente: me.precio_unit_cliente == "" ? 0 : me.precio_unit_cliente,

          utilidad_unit_distribuidor: me.utilidad_unit_distribuidor == "" ? 0 : me.utilidad_unit_distribuidor,
          precio_unit_distribuidor: me.precio_unit_distribuidor == "" ? 0 : me.precio_unit_distribuidor,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data.respuesta });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      } else {
        axios.post("api/Productos/Crear", {
          idcategoria: me.idcategoria,
          idmarca: me.idmarca,
          idunidad_medida: me.idunidad_medida,
          imagen: me.imagen == "" ? me.imagenxdefec : me.imagen,
          codigo_barra: me.codigo_barra = null ? '' : me.codigo_barra,
          codigo_producto: me.codigo_producto == null ? '' : me.codigo_producto,
          codigo_producto2: me.codigo_producto2 == null ? '' : me.codigo_producto2,

          stock_minimo: parseInt(me.stock_minimo),
          descripcion: me.descripcion,

          idprod_sunat: me.idprod_sunat,
          idtipo_afectacion: me.idtipo_afectacion,
          precio_unit_compras: me.precio_unit_compras,
          precio_unit_comprad: me.precio_unit_comprad,

          otrosd: me.otrosd == "" ? 0 : me.otrosd,
          otross: me.otross == "" ? 0 : me.otross,

          utilidad_unit_venta: me.utilidad_unit_venta == "" ? 0 : me.utilidad_unit_venta,
          precio_unit_venta: me.precio_unit_venta == "" ? 0 : me.precio_unit_venta,

          utilidad_unit_cliente: me.utilidad_unit_cliente == "" ? 0 : me.utilidad_unit_cliente,
          precio_unit_cliente: me.precio_unit_cliente == "" ? 0 : me.precio_unit_cliente,

          utilidad_unit_distribuidor: me.utilidad_unit_distribuidor == "" ? 0 : me.utilidad_unit_distribuidor,
          precio_unit_distribuidor: me.precio_unit_distribuidor == "" ? 0 : me.precio_unit_distribuidor,
        })
          .then(function (response) {
            me.desabilitar = false;
            me.snackBar({ cl: "success", msg: response.data.respuesta });
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.snackBar({ cl: "error", msg: error.response.data });
            me.listar();
          });
      }
    },
    /* Fin producto */

    /* Buscar imagen */
    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },

    /* Eliminar */
    deleteItem(item) {
      let me = this;
      const respta = confirm(
        "¿Estás seguro de eliminar el producto con Cod. " +
        item.codigo_producto +
        "?"
      );
      if (respta) {
        axios.delete("api/Productos/Eliminar/" + item.idproducto)
          .then((response) => {
            me.snackBar({ cl: "success", msg: response.data });
            this.listar();
          })
          .catch(function (error) {
            me.snackBar({ cl: "error", msg: error.response.data });
          });
      }
    },

    /* Editar */
    editItem(item) {
      this.idproducto = item.idproducto;
      this.idcategoria = item.idcategoria;
      this.selectCategoria(this.idcategoria);
      this.idmarca = item.idmarca;
      this.selectMarca(this.idmarca);
      this.idunidad_medida = item.idunidad_medida;
      this.imagen = item.imagen;
      this.codigo_barra = item.codigo_barra;
      this.codigo_producto = item.codigo_producto;
      this.codigo_producto2 = item.codigo_producto2;

      this.stock_minimo = item.stock_minimo;
      this.descripcion = item.descripcion;

      this.idprod_sunat = item.idprod_sunat;
      this.idtipo_afectacion = item.idtipo_afectacion;
      this.precio_unit_comprad = item.precio_unit_comprad;
      this.precio_unit_compras = item.precio_unit_compras;

      this.otrosd = item.otrosd;
      this.otross = item.otross;

      this.utilidad_unit_venta = item.utilidad_unit_venta;
      this.utilidad_unit_cliente = item.utilidad_unit_cliente;
      this.utilidad_unit_distribuidor =
        item.utilidad_unit_distribuidor;

      this.precio_unit_venta = item.precio_unit_venta;
      this.precio_unit_cliente = item.precio_unit_cliente;
      this.precio_unit_distribuidor = item.precio_unit_distribuidor;

      this.selectProdSunat(item.idprod_sunat);
      this.editedIndex = 1;
      this.dialog = true;
    },

    /* Cerrar */
    close() {
      this.dialog = false;
      // Limpiamos input carga de imagen -- sale error al limpiar
      //   document.getElementById("file").value = [];
      this.limpiar();
    },

    //#region CATEGORIA
    guardarCategoria() {
      let me = this;
      me.desabilitarCat = true;

      axios.post("api/Categorias/Crear", {
        nombre: me.nombre_categoria,
        descripcion: ""
      })
        .then(function (response) {
          me.desabilitarCat = false;
          me.idcategoria = response.data.idcategoria;
          me.selectCategoria(me.idcategoria);
          me.snackBar({ cl: "success", msg: response.data.mensaje });
          me.closeCategoria();
        })
        .catch(function (error) {
          me.desabilitarCat = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    mostrarCategoria() {
      this.verCategoria = true;
    },

    closeCategoria() {
      this.verCategoria = false;
      this.nombre_categoria = "";
    },
    //#endregion CATEGORIA

    //#region MARCA
    guardarMarca() {
      let me = this;
      me.desabilitarMar = true;

      axios.post("api/Marcas/Crear", {
        nombre: me.nombre_marca,
        descripcion: ""
      })
        .then(function (response) {
          me.desabilitarMar = false;
          me.idmarca = response.data.idmarca;
          //console.log(me.idmarca)
          me.selectMarca(me.idmarca);
          me.snackBar({ cl: "success", msg: response.data.mensaje });
          me.closeMarca();
        })
        .catch(function (error) {
          me.desabilitarMar = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    mostrarMarca() {
      this.verMarca = true;
    },

    closeMarca() {
      this.verMarca = false;
      this.nombre_marca = "";
    },
    //#endregion MARCA

    limpiar() {
      this.idproducto = "";
      this.idcategoria = "";
      this.idmarca = "";
      this.idunidad_medida = "NIU";
      this.imagen = "";
      this.codigo_barra = "";
      this.codigo_producto = "";
      this.codigo_producto2 = "";

      this.stock_minimo = 1;
      this.descripcion = "";

      this.idprod_sunat = "00000000";
      this.selectProdSunat(this.idprod_sunat);

      this.idtipo_afectacion = "10";
      this.precio_unit_compras = 0;
      this.precio_unit_comprad = 0;
      this.otrosd = 0;
      this.otross = 0;
      this.utilidad_unit_venta = 35;
      this.utilidad_unit_cliente = 20;
      this.utilidad_unit_distribuidor = 20;
      this.precio_unit_venta = 0;
      this.precio_unit_cliente = 0;
      this.precio_unit_distribuidor = 0;

      this.prod_sunats = []; // Limpiamos array

      this.editedIndex = -1;
      this.file = null;
      this.urlTemporal = "";
    },

    //#region KARDEX
    mostrarKardex(item) {
      this.idproducto = item.idproducto;
      this.listarKardex(this.idproducto);
      this.codigo_producto = item.codigo_producto;
      this.descripcion = item.descripcion;
      this.categoria = item.categoria;
      this.marca = item.marca;
      this.adModalKardex = 1;
    },

    cerrarKardex() {
      this.idproducto = "";
      this.codigo_producto = "";
      this.descripcion = "";
      this.categoria = "";
      this.marca = "";
      this.kardexs = [];
      this.adModalKardex = 0;
    },

    listarKardex(id) {
      let me = this;
      me.loadingKardex = true;

      axios.get("api/Movimientos/KardexProducto/" + parseInt(me.idsucursal) + "/" + me.idproducto)
        .then(function (response) {
          me.kardexs = response.data;
          me.loadingKardex = false;
          me.snackBar({ cl: "success", msg: "Kardex procesado correctamente." });
        })
        .catch((err) => {
          me.loadingKardex = false;
          me.snackBar({ cl: "error", msg: "Ocurrio un error" });
        });
    },
    //#endregion KARDEX

    //#region CODIGO BARRA
    mostrarBarCode(item) {
      this.adModalBarra = 1;
      this.codigo_barra = item.codigo_barra;
      this.codigo_producto = item.codigo_producto;
      this.codigo_producto2 = item.codigo_producto2;
      this.marca = item.marca;
      this.precio_unit_venta = item.precio_unit_venta;
      this.descripcion = item.descripcion;
    },

    cerrarBarCode() {
      this.adModalBarra = 0;
      this.codigo_barra = "";
      this.codigo_producto = "";
      this.codigo_producto2 = "";
      this.marca = "";
      this.precio_unit_venta = "";
      this.descripcion = "";

      this.cantCodigos = 1;
      document.getElementById("contenedor").innerHTML = ""; // Limpiamos comtenedor de codigo de barras
    },

    async crearBarCode() {
      let me = this;
      const contenedor = document.querySelector("#contenedor");
      // Por cada producto, crear un SVG y adjuntarlo

      //Validamos 
      if (!me.codigo_producto) { return me.snackBar({ cl: "warning", msg: "Tiene que registar el código de producto principal." }); }

      var codigoArray = [];

      for (var i = 0; i < me.cantCodigos; i++) {
        codigoArray.push({
          marca: me.marca,
          precio: "S/ " + me.common.roundOut(me.precio_unit_venta, 2),
          descripcion: me.descripcion,
          codigo_barra: me.codigo_barra,
        });
      };

      codigoArray.forEach((producto) => {
        const elemento = document.createElement("img");
        elemento.dataset.value = producto.codigo_barra;
        elemento.dataset.marca = producto.marca;
        elemento.dataset.precio = producto.precio;
        elemento.dataset.descripcion = producto.descripcion;
        elemento.classList.add("codigo_barra");
        contenedor.appendChild(elemento);
      });

      Barcode(".codigo_barra")
        .options({
          format: "CODE128", // El formato
          width: 7, // La anchura de cada barra
          height: 60, // La altura del código
          displayValue: false,
          marginTop: 5, // Margen superior
          marginRight: 5, // Margen derecho
          marginBottom: 5, // Margen inferior
          marginLeft: 5, // Margen izquierdo
          //fontSize: 40,
        })
        .init();

      const nodeMap = await document.getElementById("contenedor").childNodes;

      var arrayProducto = [];
      for (let i = 0; i < nodeMap.length; i++) {
        arrayProducto.push({
          codigo_barra: nodeMap[i].dataset.value,
          img: nodeMap[i].currentSrc,
          marca: nodeMap[i].dataset.marca,
          precio: nodeMap[i].dataset.precio,
          descripcion: nodeMap[i].dataset.descripcion,
        });
      }

      var doc = new jsPDF("l", "mm", [48, 23.1]); // ancho x alto en milímetros

      const pageWidth = doc.internal.pageSize.getWidth();
      const imageWidth = 25;
      const imageX = (pageWidth - imageWidth) / 2;

      arrayProducto.forEach((producto, i) => {
        if (i > 0) doc.addPage(); // solo agregar página a partir del segundo producto

        // Titulo
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text(producto.marca.slice(0, 30), pageWidth / 2, 5, { align: "center" }); // centrado en 48mm

        // Descripción
        doc.setFontSize(5);
        doc.setFont("helvetica", "normal");
        const descripcion1 = producto.descripcion.slice(0, 33);
        doc.text(descripcion1, pageWidth / 2, 8, { align: "center" });
        // Precio
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(producto.precio, pageWidth / 2, 11, { align: "center" });

        doc.setFontSize(4);
        doc.setFont("helvetica", "normal");
        doc.text(me.datos.sucursal.slice(0, 12), 34, 11);

        // Imagen del código de barras
        // El tamaño 30mm x 10mm es adecuado para este tipo de etiquetas
        doc.addImage(producto.img, "PNG", imageX, 12.5, imageWidth, 5.08); // x, y, width, height

        doc.setFont("helvetica", "bold");
        doc.setFontSize(7);
        doc.text(producto.codigo_barra, pageWidth / 2, 20, { align: "center" });
      });

      // Exportar
      //doc.save("CodBarra " + me.codigo_producto + me.marca + ".pdf");
      doc.setProperties({
        title: "Codigo Barra " + me.codigo_producto + me.marca
      });
      doc.output('dataurlnewwindow');

      document.getElementById("contenedor").innerHTML = ""; // Limpiamos comtenedor de codigo de barras
    },

    async crearBarCodeA4() {
      let me = this;
      const contenedor = document.querySelector("#contenedor");
      // Por cada producto, crear un SVG y adjuntarlo

      //Validamos 
      if (!me.codigo_producto) { return me.snackBar({ cl: "warning", msg: "Tiene que registar el código de producto principal." }); }

      var codigoArray = [];

      for (var i = 0; i < me.cantCodigos; i++) {
        codigoArray.push({
          codigos: me.codigo_producto + " | " + me.codigo_producto2,
          marca_precio: me.marca + " | " + me.common.roundOut(me.precio_unit_venta / me.tc, 2),
          descripcion: me.descripcion,
          codigo_barra: me.codigo_barra,
        });
      };

      codigoArray.forEach((producto) => {
        const elemento = document.createElement("img");
        elemento.dataset.value = producto.codigo_barra;
        elemento.dataset.codigos = producto.codigos;
        elemento.dataset.marca_precio = producto.marca_precio;
        elemento.dataset.descripcion = producto.descripcion;
        elemento.classList.add("codigo_barra");
        contenedor.appendChild(elemento);
      });

      Barcode(".codigo_barra")
        .options({
          format: "CODE128", // El formato
          width: 5, // La anchura de cada barra
          height: 200, // La altura del código
          displayValue: true,
          marginTop: 5, // Margen superior
          marginRight: 5, // Margen derecho
          marginBottom: 5, // Margen inferior
          marginLeft: 5, // Margen izquierdo
          fontSize: 40,
        })
        .init();

      const nodeMap = await document.getElementById("contenedor").childNodes;

      var arrayProducto = [];
      for (let i = 0; i < nodeMap.length; i++) {
        arrayProducto.push({
          codigo_barra: nodeMap[i].dataset.value,
          img: nodeMap[i].currentSrc,
          codigos: nodeMap[i].dataset.codigos,
          marca_precio: nodeMap[i].dataset.marca_precio,
          descripcion: nodeMap[i].dataset.descripcion,
        });
      }

      // Agregar Encabezado: titulo y logo
      const addBody = (doc) => {
        const medio = (doc.internal.pageSize.width / 2) + 10;
        const medio2 = medio / 4;

        const columnWidth = 50; // Ancho de cada columna
        const rowHeight = 35;   // Alto de cada fila
        const numRows = Math.ceil(arrayProducto.length / 4); // Cantidad de filas necesarias

        let salto = 10;

        // Recorrer por filas y columnas
        for (let row = 0; row < numRows; row++) {
          for (let col = 0; col < 4; col++) {
            const index = row * 4 + col;
            if (index >= arrayProducto.length) {
              break; // Si no hay más productos, salir del bucle interno
            }
            doc.setFontSize(7);
            doc.setFont("helvetica", "bold");
            doc.text(me.datos.sucursal, col * columnWidth + medio2, salto, { align: "center" });
            doc.setFont("helvetica", "normal");
            doc.text(arrayProducto[index].codigos, col * columnWidth + medio2, salto + 3, { align: "center" });
            doc.text(arrayProducto[index].marca_precio, col * columnWidth + medio2, salto + 6, { align: "center" });

            // Dividir la descripción en dos líneas
            const descripcion1 = arrayProducto[index].descripcion.slice(0, 25);
            const descripcion2 = arrayProducto[index].descripcion.slice(25, 50);
            doc.text(descripcion1, col * columnWidth + medio2, salto + 9, { align: "center" });
            doc.text(descripcion2, col * columnWidth + medio2, salto + 12, { align: "center" });

            // Imagen Codigo Barra
            doc.addImage(arrayProducto[index].img, "PNG", col * columnWidth + 10, salto + 13, 40, 13.44);
          }
          // Verificar si se necesita una nueva página (más de 7 líneas)
          if (salto + rowHeight > doc.internal.pageSize.height - 10) {
            doc.addPage();
            salto = 10; // Reiniciar el valor de salto en la nueva página
          } else {
            // Incrementar el salto para la próxima fila
            salto += rowHeight;
          }
        }
      };
      var doc = new jsPDF("p", "mm", [210, 297]);

      addBody(doc);
      // Exportar
      //doc.save("CodBarra " + me.codigo_producto + me.marca + ".pdf");
      doc.setProperties({
        title: "Codigo Barra " + me.codigo_producto + me.marca
      });
      doc.output('dataurlnewwindow');

      document.getElementById("contenedor").innerHTML = ""; // Limpiamos comtenedor de codigo de barras
    },
    //#endregion CODIGO BARRA

    /* Desactivar, activar */
    desactivar() {
      let me = this;

      axios.put("api/Productos/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.codigo_producto;
      this.adId = item.idproducto;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;

      axios.put("api/Productos/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar */

    crearPDF() {
      var columns = [
        { header: "COD.PRODUCTO", dataKey: "codigo_producto" },
        { header: "DESCRIPCIÓN", dataKey: "descripcion" },
        { header: "CATEGORÍA", dataKey: "categoria" },
        { header: "MARCA", dataKey: "marca" },

        { header: "C", dataKey: "condicion" },
      ];
      var body = [];

      this.productos.map(function (x) {
        body.push({
          codigo_producto: x.codigo_producto,
          descripcion: x.descripcion,
          categoria: x.categoria,
          marca: x.marca,

          condicion: x.condicion == 1 ? "A" : "I",
        });
      });

      // Titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "LISTADO DE PRODUCTOS",
            doc.internal.pageSize.width / 2,
            45,
            {
              align: "center",
            }
          );
          doc.addImage(imgData, "JPEG", 40, 17, 70, 49.39);
        }
      };
      // Pie de pagina
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      var imgData = "data:image/png;base64," + this.logo;
      var doc = new jsPDF("p", "pt");

      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 6 },

        columnStyles: {
          codigo_producto: { cellWidth: 70 },
          descripcion: { cellWidth: 285 },
          categoria: { cellWidth: 70 },
          marca: { cellWidth: 70 },
          condicion: { cellWidth: 20.28, halign: "center" },
        },
      });
      // 761.89 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Productos.pdf");
    },

    crearXLSX() {
      var rows = [];

      this.productos.map(function (x) {
        rows.push({
          "IdProducto": x.idproducto,
          "Cód. producto": x.codigo_producto,
          "Cód. producto 2": x.codigo_producto2,
          "Cód. barras": x.codigo_barra,
          Categoría: x.categoria,
          Marca: x.marca,
          Descripción: x.descripcion,
          "Stock Minimo": x.stock_minimo,
          "P/U/Compra $": x.precio_unit_comprad,
          "P/U/Compra S/": x.precio_unit_compras,

          "Otros $": x.otrosd,
          "Otros S/": x.otross,

          "Ganancia Venta": x.utilidad_unit_venta,
          "P/U/Venta": x.precio_unit_venta,

          "Ganancia Cliente": x.utilidad_unit_cliente,
          "P/U/Cliente": x.precio_unit_cliente,

          "Ganancia Distribuidor": x.utilidad_unit_distribuidor,
          "P/U/Distribuidor": x.precio_unit_distribuidor,
          "Stock": x.stockactual,
          Condición: x.condicion == 1 ? "A" : "I",
        });
      });

      var Producto = XLSX.utils.json_to_sheet(rows);

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, Producto, "productos");

      // export Excel file
      XLSX.writeFile(wb, this.sucursal + " Lista Productos.xlsx");
    },
  },
};
</script>
<style scoped>
.center-input>>>input {
  text-align: center;
}
</style>
</style>